module.exports = __webpack_public_path__ + "media/images/rank_02-53379ea0cdab0d361731bb4e83888e03.png";